module.exports = __webpack_public_path__ + "img/diners-club.efb57e47.png";